function useLimitDigits({ value, decimalPoints, maximumDigits, }) {
    let maxLimit = maximumDigits === undefined || maximumDigits === 'none'
        ? -1
        : maximumDigits;
    const num = Number(value);
    const integerPart = num.toString().split('.')[0];
    let decimalPart = num.toString().split('.')[1] || '';
    if (decimalPoints) {
        maxLimit = -1;
        decimalPart =
            decimalPart.slice(0, decimalPoints) +
                '0'.repeat(Math.max(decimalPoints - decimalPart.length, 0));
    }
    if (maxLimit === -1) {
        return decimalPoints
            ? `${integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${decimalPart}`
            : integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    if (integerPart.length > maxLimit) {
        const trucatedNum = '9'.repeat(maxLimit);
        return `${trucatedNum}+`;
    }
    return `${integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
}

export { useLimitDigits as default };
